// =====================================================================
// NEURAL MEDIA SOLUTIONS — All Site Data
// =====================================================================

export const COMPANY = {
  name:     'Neural Media Solutions',
  tagline:  'Your One Stop Marketing Solution',
  phone:    '+91 72900 66328',
  email:    'neuralmediasolutions@gmail.com',
  address:  'OFFICER CITY, 2, Raj Nagar Extension Rd, Raj Nagar Extension, Ghaziabad, Uttar Pradesh 201003',
  hours:    'Mon–Sat: 9 AM – 7 PM IST',
  whatsapp: 'https://wa.me/917290066328',
  adSpend:  '₹40L+',
  clients:  '20+',
  leads:    '5,000+',
  startPrice: '₹8,000',
  social: {
    instagram: 'https://instagram.com/neuralmediasolutions',
    facebook:  'https://facebook.com/neuralmediasolutions',
    linkedin:  'https://linkedin.com/company/neuralmediasolutions',
    whatsapp:  'https://wa.me/917290066328',
  },
};

export const SERVICES = [
  {
    id:     'meta',
    icon:   '◈',
    title:  'Meta Ads',
    short:  'Facebook & Instagram Ads',
    color:  '#00E5CC',
    bg:     'rgba(0,229,204,0.07)',
    border: 'rgba(0,229,204,0.2)',
    desc:   'Advanced audience segmentation, lookalike audiences, lead gen forms, and carousel ads showcasing your properties to serious buyers.',
    bullets: ['High-quality, pre-qualified inquiries','Targeted reach to potential buyers','Enhanced brand awareness','Cost-effective campaigns'],
    forDevelopers:     ['Large-scale project launches','Multi-city audience targeting','Bulk inquiry generation','High ad spend management (₹2L+/mo)'],
    forChannelPartners:['Hyper-local targeting by project','Quick-response lead gen forms','Budget-friendly micro-campaigns','Realtor branding & visibility'],
  },
  {
    id:     'google',
    icon:   '◉',
    title:  'Google Ads',
    short:  'Search & Display Campaigns',
    color:  '#FF6B35',
    bg:     'rgba(255,107,53,0.07)',
    border: 'rgba(255,107,53,0.2)',
    desc:   'Capture high-intent buyers actively searching for properties. Strategic keyword research, compelling ad copy, bidding optimization & remarketing.',
    bullets: ['Instant visibility for ready buyers','High conversion rates','Measurable ROI','Competitive market advantage'],
    forDevelopers:     ['Brand keyword domination','Competitor conquest campaigns','High-volume search traffic','Display & YouTube ads for launches'],
    forChannelPartners:['Low-budget, high-ROI search ads','Location-specific keyword targeting','Inquiry quality over quantity','Flexible daily budgets'],
  },
  {
    id:     'social',
    icon:   '◎',
    title:  'Social Media Management',
    short:  'Content, Growth & Engagement',
    color:  '#F7C948',
    bg:     'rgba(247,201,72,0.07)',
    border: 'rgba(247,201,72,0.2)',
    desc:   'Build and maintain a powerful social presence. Content creation, community management, and strategic posting for sustained organic growth.',
    bullets: ['Enhanced brand authority','Community building & engagement','Improved organic reach','Trust & nurturing'],
    forDevelopers:     ['Premium content for large projects','Drone footage & virtual tours','Multi-platform brand consistency','Press & media amplification'],
    forChannelPartners:['Personal brand building','Client testimonial showcasing','Market updates & tips content','WhatsApp broadcast integration'],
  },
  {
    id:     'branding',
    icon:   '✦',
    title:  'Ad Branding & Promotion',
    short:  'Brand Identity & Promotions',
    color:  '#9B8AF8',
    bg:     'rgba(155,138,248,0.07)',
    border: 'rgba(155,138,248,0.2)',
    desc:   'Build a powerful real estate brand that stands apart. From visual identity and ad creatives to promotional campaigns that make your brand unforgettable.',
    bullets: ['Brand identity & design system','Creative ad production','Promotional campaign strategy','Market positioning & messaging'],
    forDevelopers:     ['Full brand development & guidelines','Launch event digital promotions','High-end video & creative assets','PR amplification through paid media'],
    forChannelPartners:['Personal brand kit & templates','Property listing promotional creatives','Festival & occasion branding','Consistent visual identity across platforms'],
  },
];

export const CLIENTS = [
  { name: 'Royal Divine (R.D.LLP)', init: 'RD',  color: '#F7C948', logo: 'client_royaldivine.jpeg' },
  { name: 'The Red Planet',         init: 'RP',  color: '#FF6B35', logo: 'client_redplanet.jpeg'   },
  { name: 'Sold In Sight',          init: 'SI',  color: '#00E5CC', logo: 'client_soldinsight.webp' },
  { name: 'SRD',                    init: 'SRD', color: '#9B8AF8', logo: 'client_srd.png'          },
];

export const CASE_STUDIES = [
  {
    client:    'Royal Divine (R.D.LLP)',
    init:      'RD',
    color:     '#F7C948',
    logo:      'client_royaldivine.jpeg',
    type:      'Developer',
    challenge: 'Needed consistent high-quality inquiries for new luxury residential projects, struggling with inconsistent results from previous efforts.',
    solution:  'Comprehensive Meta campaign + targeted Google Search Ads with bespoke creatives and advanced lookalike audiences.',
    metrics:   [{ val: '₹10L+', label: 'Ad Spend Managed' },{ val: '3×', label: 'Inquiry Quality Lift' },{ val: '−40%', label: 'Cost Per Inquiry' }],
    quote: 'Neural Media Solutions exceeded our expectations. Their inquiries were of superior quality, leading to quicker conversions.',
  },
  {
    client:    'The Red Planet',
    init:      'RP',
    color:     '#FF6B35',
    logo:      'client_redplanet.jpeg',
    type:      'Developer',
    challenge: 'Needed to amplify online presence and generate steady qualified buyers for high-end projects facing increasing competition.',
    solution:  'Multi-channel strategy: Google Search for buyer intent + Meta Ads for brand storytelling and inquiry capture.',
    metrics:   [{ val: '+180%', label: 'Website Traffic' },{ val: '₹12L+', label: 'Ad Spend Managed' },{ val: '+65%', label: 'Conversion Rate' }],
    quote: 'Neural Media Solutions delivered exceptional results, significantly boosting our inquiries and brand reach.',
  },
  {
    client:    'Sold In Sight',
    init:      'SI',
    color:     '#00E5CC',
    logo:      'client_soldinsight.webp',
    type:      'Channel Partner',
    challenge: 'Aimed to build personal brand as a channel partner and generate higher volume of pre-screened inquiries in a competitive market.',
    solution:  'Social media brand building with engaging content + strategic Google Search ads targeting location-specific buyer keywords.',
    metrics:   [{ val: '+120%', label: 'Social Inquiry Volume' },{ val: '₹6L+', label: 'Pipeline Value' },{ val: '+85%', label: 'Brand Engagement' }],
    quote: 'Neural Media Solutions brought fresh strategies that significantly improved our online inquiry flow and brand visibility.',
  },
  {
    client:    'SRD',
    init:      'SRD',
    color:     '#9B8AF8',
    logo:      'client_srd.png',
    type:      'Channel Partner',
    challenge: 'Wanted to differentiate in a crowded channel partner space and attract quality clients through a stronger digital presence.',
    solution:  'Personal branding via social media management + Meta Ads targeting property seekers in specific micro-markets.',
    metrics:   [{ val: '+90%', label: 'Profile Reach' },{ val: '2.5×', label: 'Inquiry Quality Lift' },{ val: '−35%', label: 'Cost Per Inquiry' }],
    quote: 'Our brand visibility transformed completely. We now get inbound inquiries we never had before.',
  },
];

export const TESTIMONIALS = [
  { name: 'Royal Divine (R.D.LLP)', role: 'Real Estate Developer',      logo: 'client_royaldivine.jpeg', review: 'Neural Media Solutions transformed our digital marketing. The quality of inquiries we now receive is unmatched. Our sales team loves the pre-qualified contacts.', rating: 5, color: '#F7C948' },
  { name: 'The Red Planet',         role: 'Property Developer',          logo: 'client_redplanet.jpeg',   review: 'Their Meta and Google Ads strategy brought us serious buyers, not just inquiries. Conversion rates improved by 65% within two months of working together.', rating: 5, color: '#FF6B35' },
  { name: 'Sold In Sight',          role: 'Channel Partner',             logo: 'client_soldinsight.webp', review: 'The social media branding gave us a professional edge. Clients trust us more because of our consistent online presence crafted by Neural Media Solutions.', rating: 5, color: '#00E5CC' },
  { name: 'SRD',                    role: 'Channel Partner',             logo: 'client_srd.png',          review: 'We saw a 90% increase in profile reach and started getting inbound inquiries within weeks. The ROI has been outstanding.', rating: 5, color: '#9B8AF8' },
];

export const PLANS = [
  {
    name:    'Social Media',
    price:   '₹8,000',
    period:  '/month',
    tagline: 'For channel partners & independent realtors',
    color:   '#F7C948',
    popular: false,
    features: ['Social Media Management (Instagram & Facebook)','Content creation & posting (12 posts/mo)','Community management & replies','Monthly strategy call','Bi-weekly performance reports','WhatsApp support'],
  },
  {
    name:    'Meta / Google Ads',
    price:   '₹15,000',
    period:  '/month',
    tagline: 'For developers wanting high-quality inquiries',
    color:   '#00E5CC',
    popular: false,
    features: ['1 paid channel (Meta or Google Ads)','Up to ₹1 Lakh monthly ad spend','Campaign setup & creative development','Weekly optimization & A/B testing','Bi-weekly performance reports','Dedicated account manager','WhatsApp support'],
  },
  {
    name:    'Growth Bundle',
    price:   '₹20,000',
    period:  '/month',
    tagline: 'Best value — Meta Ads + Social Media',
    color:   '#FF6B35',
    popular: true,
    features: ['Meta Ads + Social Media Management','Up to ₹1.5 Lakh monthly ad spend','Full creative production','Weekly strategy calls','Real-time dashboard access','Advanced audience targeting','Dedicated account manager','Priority WhatsApp + call support'],
  },
  {
    name:    'Branding & Promotion',
    price:   'Custom',
    period:  '',
    tagline: 'For developers needing full brand presence',
    color:   '#9B8AF8',
    popular: false,
    features: ['Brand identity & design system','All channels — Meta, Google, Social','Unlimited ad spend management','Full creative studio access','Custom landing pages & funnels','CRM integration & tracking','Dedicated team of specialists','Monthly strategy briefing'],
  },
];

export const BLOG_POSTS = [
  { title: 'Mastering Meta Ads for Luxury Properties',              cat: 'Meta Ads',   date: 'Jun 24, 2025', read: '8 min',  color: '#00E5CC', excerpt: 'Advanced targeting techniques and creative strategies to attract high-net-worth individuals for luxury real estate listings.' },
  { title: 'Google Ads: Driving Intent-Driven Buyers',              cat: 'Google Ads', date: 'Jun 15, 2025', read: '10 min', color: '#FF6B35', excerpt: 'How to optimize Google Search campaigns to capture buyers actively searching for properties and ensure top-of-page placement.' },
  { title: 'Building Your Real Estate Brand on Social Media',       cat: 'Social Media',date: 'Jun 1, 2025', read: '7 min',  color: '#F7C948', excerpt: 'Organic social media growth, content ideas, and community engagement strategies to establish real estate brand authority.' },
  { title: 'Why Branding Matters More Than Ever in Real Estate',    cat: 'Branding',   date: 'May 20, 2025', read: '6 min',  color: '#9B8AF8', excerpt: 'In a competitive market, a strong brand identity sets you apart. Here\'s how top developers are winning with brand-first marketing.' },
  { title: 'Developers vs Channel Partners: Different Strategies',  cat: 'Strategy',   date: 'May 10, 2025', read: '9 min',  color: '#00E5CC', excerpt: 'The marketing approach for a developer launching a township is very different from a channel partner selling individual units. Here\'s why.' },
  { title: 'How to Reduce Your Cost Per Inquiry by 40%',            cat: 'Performance', date: 'Apr 28, 2025', read: '7 min',  color: '#FF6B35', excerpt: 'Data-driven optimizations and creative testing strategies that our team uses to consistently drive down cost per inquiry for real estate clients.' },
];

export const FAQS = [
  { q: 'What services do you offer?', a: 'We specialize in real estate digital marketing — Meta Ads, Google Ads, Social Media Management, and Branding & Promotion. All campaigns are built specifically for property developers, builders, and channel partners.' },
  { q: 'How quickly will I see results?', a: 'Most clients see their first qualified inquiries within 7–10 days of campaign launch. Full optimization typically happens over the first 30–45 days as we gather data and refine targeting.' },
  { q: 'What is your pricing?', a: 'Social Media Management starts at ₹8,000/month. Meta or Google Ads at ₹15,000/month. The Growth Bundle (Meta + Social) is ₹20,000/month. Branding & full-scale packages are custom priced. Contact us for a tailored quote.' },
  { q: 'Do you work with both developers and channel partners?', a: 'Yes! We have tailored strategies for both. Developers get large-scale campaign management and launch support, while channel partners get personal branding and targeted inquiry generation.' },
  { q: 'Do you work with clients outside Delhi NCR?', a: 'Yes! We work with real estate businesses across India. Our core expertise is in Delhi NCR / Ghaziabad but we manage campaigns for clients in Mumbai, Pune, Hyderabad, and beyond.' },
];

export const FORM_STEPS = [
  {
    title: "Let's get started 👋",
    sub:   'Tell us about yourself',
    fields: [
      { key: 'name',  label: 'Full Name *',       placeholder: 'Rajesh Kumar',       type: 'text'  },
      { key: 'phone', label: 'WhatsApp Number *', placeholder: '+91 98765 43210',     type: 'tel'   },
      { key: 'email', label: 'Email Address *',   placeholder: 'rajesh@company.com', type: 'email' },
    ],
  },
  {
    title: 'About your project 🏗️',
    sub:   'Help us understand your needs',
    fields: [
      { key: 'company',  label: 'Company / Project Name', placeholder: 'Royal Divine – Raj Nagar Extension', type: 'text' },
      { key: 'location', label: 'Project Location',       placeholder: 'Ghaziabad, Noida, Delhi NCR…',        type: 'text' },
      { key: 'service',  label: 'Service Needed',         type: 'select', options: ['Meta Ads (Facebook & Instagram)', 'Google Ads', 'Social Media Management', 'Ad Branding & Promotion', 'Growth Bundle (Meta + Social)', 'Not Sure – Need Guidance'] },
      { key: 'type',     label: 'I am a',                 type: 'select', options: ['Developer / Builder', 'Channel Partner / Realtor', 'Real Estate Agency', 'Other'] },
    ],
  },
  {
    title:    'Budget & goals 🎯',
    sub:      'So we can recommend the right plan',
    required: false,
    fields: [
      { key: 'budget',  label: 'Monthly Budget (Optional)',        type: 'select',   options: ['Under ₹20,000', '₹20,000 – ₹50,000', '₹50,000 – ₹2 Lakh', '₹2 Lakh+', 'Not decided yet'] },
      { key: 'message', label: 'Tell us about your goals (Optional)', placeholder: 'e.g. We want quality inquiries for our new 2BHK project…', type: 'textarea' },
    ],
  },
];
